import { useState } from "react";
import {
  CSSTransition,
  Transition,
  TransitionGroup,
} from "react-transition-group";

const ColasTypeInfosItem = ({ infos, filters }) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  //--- Get activity type slug
  let activitySlug = "";
  for (const activity of filters[Object.keys(filters)[0]].values) {
    if (activity.name === infos.name) {
      activitySlug = activity.slug;
    }
  }

  //--- Format Email
  let displayEmail = [];
  if (infos.email && Object.entries(infos.email).length > 0) {
    const formatedEmail = Object.entries(infos.email);
    displayEmail = formatedEmail.map((elt, index) => {
      const [person, email] = elt;
      return (
        <div className={`email ${activitySlug}-icon`} key={elt[1] + index}>
          <div key={email + index}>
            <div className="text-bold">{person} : </div>
            <div>{email}</div>
          </div>
        </div>
      );
    });
  }

  //--- Format phone
  let displayPhone = [];
  if (infos.phone && Object.entries(infos.phone).length > 0) {
    const formatedPhone = Object.entries(infos.phone);
    displayPhone = formatedPhone.map((elt, index) => {
      const [person, phone] = elt;
      return (
        <div className={`phone ${activitySlug}-icon`} key={elt[1] + index}>
          <div className="d-flex" key={phone + index}>
            <div className="text-bold">{person} : </div>
            <div>&nbsp;{phone}</div>
          </div>
        </div>
      );
    });
  }

  //--- Format Schedule
  let displaySchedule = [];
  if (infos.schedule && Object.entries(infos.schedule).length > 0) {
    const formatedSchedule = Object.entries(infos.schedule);
    displaySchedule = formatedSchedule.map((elt, index) => {
      const [day, hours] = elt;
      return (
        <div className={`schedule ${activitySlug}-icon`} key={elt[1] + index}>
          <div key={day + index}>
            <div className="text-bold">{day} : </div>
            <div>{hours}</div>
          </div>
        </div>
      );
    });
  }

  //--- Get the color

  let color = "";
  for (const filter of filters[Object.keys(filters)[0]].values) {
    if (filter.name === infos.name) {
      color = filter.color;
    }
  }

  return (
    <div className="row no-gutters mb-5">
      <div className="colas-info-type-item col-12 ">
        <div
          onClick={() => handleOpen()}
          className={`colas-info-type-item__title ${isOpen ? "open" : ""}`}
        >
          <div className="row no-gutters">
            {infos.name && (
              <div
                className="colas-info-type-item__title-wrapper col-auto"
                style={{
                  backgroundColor: `${color}`,
                  color: "white",
                  padding: "5px 10px",
                }}
              >
                {infos.name}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-12">
        {/* <CSSTransition in={isOpen} timeout={700} appear unmountOnExit classNames="infos-transition">
          {(isOpen) => (
            <div className="row no-gutters colas-info-type-item__infos">
              {infos.address && <div className="address">{infos.address}</div>}
              {infos.addressComplement && <div className="address-complement">{infos.addressComplement}</div>}
              <div className="email">{displayEmail}</div>
              <div className="phone">{displayPhone}</div>
              <div className="schedule">{displaySchedule}</div>
            </div>
          )}
        </CSSTransition> */}
        {isOpen && (
          <div className="row no-gutters colas-info-type-item__infos">
            {infos.address && (
              <div className={`address ${activitySlug}-icon`}>
                {infos.address}
              </div>
            )}
            {infos.addressComplement && (
              <div className="address-complement">
                {infos.addressComplement}
              </div>
            )}
            {displayEmail}
            {displayPhone}
            {displaySchedule}
          </div>
        )}
      </div>
    </div>
  );
};

export default ColasTypeInfosItem;
